module.exports = __webpack_public_path__ + "img/ai_picture.5ee23b18.jpg";